import { InputBase, alpha, styled } from "@mui/material";
import { debounce } from "../helper/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.05),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.1),
  },
  marginLeft: 0,
  [theme.breakpoints.up("sm")]: {
    width: "30rem",
  },
  border: "0.06rem solid #E4E4E4"
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(7)})`,
    [theme.breakpoints.up("sm")]: {
      width: "30rem"
    },
  },
}));

const delayInMilliseconds: number = 1000;

export const SearchBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState<string>("");

  const handle = (event: any) => {
    const gadgetName = event.target.value;
    const q = new URLSearchParams(location.search);
    q.set("name", gadgetName);
    q.set("page_no", "0");
    navigate(location.pathname + "?" + q.toString());
  };

  const handledOnChange = (event: any) => {
    setValue(event.target.value);
    return debounce(handle, delayInMilliseconds);
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const gName = query.get('name') || "";
    setValue(gName);
  }, [location]);
  
  return (
    <Search id="agents">
      <SearchIconWrapper>
        <FontAwesomeIcon icon={faMagnifyingGlass} size="2x"/>
      </SearchIconWrapper>
      <StyledInputBase
        placeholder="Search Agent..."
        inputProps={{ "aria-label": "search" }}
        onChange={(event) => handledOnChange(event)(event)}
        value={value}
      />
    </Search>
  );
};
